<template>
  <ControlUnit :title="$t('control.panel.widget_button')">
    <InputRadio
      :name="unitName"
      :value="currentButtonMode"
      :options="buttonModes"
      @change="changeHandler"
    />
  </ControlUnit>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import { runAllWithData } from '@/helpers/functional';

import useStateController from './useStateController';
import useRouteController from './useRouteController';

import ControlUnit from './ControlUnit.vue';
import InputRadio from './InputRadio.vue';

export default {
  components: {
    ControlUnit,
    InputRadio,
  },
  setup() {
    const unitName = 'button-mode';

    const store = useStore();

    const buttonModes = store.state.control.buttonModes;

    const currentButtonMode = computed(() => {
      return store.state.control.currentButtonMode;
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      const unitQueryValue = getRouterQueryValue(unitName);

      changeControlHandler({
        type: unitName,
        value: unitQueryValue,
      });
    });

    return {
      unitName,
      buttonModes,
      currentButtonMode,
      changeHandler,
    };
  },
};
</script>
